import { SVGInstance } from "../../../browser/instance/SVGInstance.js";
import { SVGLinearGradientInstance } from "../../instances/SVGLinearGradientInstance.js";
export class GradientInstances extends SVGInstance {
    addLinearGradient() {
        const linearGradient = new SVGLinearGradientInstance(this);
        this.appendInstance(linearGradient);
        return linearGradient;
    }
}
//# sourceMappingURL=gradientInstances.js.map